import { Routes } from '@angular/router';
import { EuProjectsComponent } from './container/eu-projects.component';

export const EU_PROJECTS_ROUTES: Routes = [
    {
        path: '',
        component: EuProjectsComponent,
    },
];
